var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EY_Styles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EY_CTAs_Desktop-and-Tablet",
    transform: "translate(-1155.000000, -3090.000000)",
    fill: "#2E2E38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-Light-BG",
    transform: "translate(790.000000, 3012.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default",
    transform: "translate(84.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube-Light-BG",
    transform: "translate(270.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.54025,17.3422984 C33,19.0133468 33,22.5 33,22.5 C33,22.5 33,25.9865323 32.54025,27.6578226 C32.28725,28.5797177 31.541875,29.3057661 30.595125,29.5522984 C28.879625,30 22,30 22,30 C22,30 15.120375,30 13.40475,29.5522984 C12.458125,29.3057661 11.712625,28.5797177 11.459625,27.6578226 C11,25.9865323 11,22.5 11,22.5 C11,22.5 11,19.0133468 11.459625,17.3422984 C11.712625,16.4202823 12.458125,15.6942339 13.40475,15.4478226 C15.120375,15 22,15 22,15 C22,15 28.879625,15 30.595125,15.4478226 C31.541875,15.6942339 32.28725,16.4202823 32.54025,17.3422984 Z M19.7499625,25.6656169 L25.4999625,22.5001331 L19.7499625,19.3344073 L19.7499625,25.6656169 Z",
    id: "youtube"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.d7e10d6d4186488de498950add417e18.svg";
export { ForwardRef as ReactComponent };